<template>
  <div id="app">
    <gotop></gotop>
    <router-view />
  </div>
</template>

<script>
import gotop from './components/modle/gotop'

export default {
  name: 'App',
  components: {
    gotop
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
}

* {
  box-sizing: border-box;
}

.bluebtn {
  background-color: #009aff;

}

.bluebtn:hover {
  background-color: #498ab5;
  background-clip: padding-box;
  border-color: #000;
}

@media (max-width: 800px) {
  .no_mobile {
    display: none;
  }

}

@media (min-width: 800px) {
  .no_pc {
    display: none;
  }

}

.shouzhi {
  cursor: pointer;
}

.width1300 {

  max-width: 1058px;
  margin: 0 auto;
  overflow: hidden;
}

.ispc {
  min-width: 800px !important;
}
</style>
